import React from 'react';
import { useWindowSize } from 'react-use';

/**
 * Hook for determining what screen class is being used by the user.
*/
export const useDeviceClassification = () => {
    const { width, height } = useWindowSize();

    return {
        width: width,
        isMobile: width <= 800,
        isTablet: width <= 1024,
        isDesktop: width > 1024,
        isHD: width >= 1600,
        height: height
    };
}
